import React from 'react';
import { decodeText } from '../libs/utils/Const';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action, switch1) => {
    let body: "";

    body = data.map((register, index) => {
        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 100 }}>
                    <button type="button" className="btn btn-sm "
                        onClick={() => action({ index })}
                        style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }}>
                        <i className="fas fa-check"></i>
                    </button>
                </td>
                <td>{register.WhsCode || ""}</td>
                <td className="overflow-visible">{decodeText(register.WhsName) || ""}</td>
                {switch1 === true && (<td>{(Number(register.OnHand) || 0).toFixed(4)}</td>)}{/*708*/}
                {switch1 === true && (<td>{(Number(register.IsCommited) || 0).toFixed(4)}</td>)}
                {switch1 === true && (<td>{(Number(register.OnOrder) || 0).toFixed(4)}</td>)}
                {switch1 === true && (<td>{(Number(register.sugerencia) || 0).toFixed(4)}</td>)}

            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, switch1) => {

    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow " style={{ width: 100 }}></td>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            {switch1 === true && (<td className="sticky-header table-header-yellow ">{headers[2].title}</td>)}
            {switch1 === true && (<td className="sticky-header table-header-yellow ">{headers[3].title}</td>)}
            {switch1 === true && (<td className="sticky-header table-header-yellow ">{headers[4].title}</td>)}
            {switch1 === true && (<td className="sticky-header table-header-yellow ">{headers[4].title}</td>)}

        </tr>;
    }

    body = renderTableBody(headers, data, action, switch1);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableWarehouseModal = (headers, data, action, switch1) => {

    return renderTable(headers, data, action, switch1);

}
